import axios from 'axios';

const state = {};

const getters = {};

const actions = {
	// Interesse di ricerca della parola chiave di un prodotto in una lingua (Google Trends).
	// Ritorna { data } oppure { error: { message } }.
	fetchItem: async (context, payload) => {
		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}googletrends/item`,
				{ keyword: payload.keyword, lang: payload.lang, geo: payload.geo || undefined },
				{ headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` } },
			)
			.then(res => res.data)
			.catch(err => ({ error: err.response ? err.response.data : { message: err.message } }));
	},
};

const mutations = {};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
